/* NOELVA recensioner (Shape Lab .sl-sp): karusell med pilar, videor som spelas när de syns, förstoring vid tryck. */
(function(){
  document.querySelectorAll('[data-rv]').forEach(function(root){
    var track=root.querySelector('[data-rv-track]'); if(!track)return;
    var arrows=[].slice.call(root.querySelectorAll('[data-rv-arrow]'));
    function upd(){var max=track.scrollWidth-track.clientWidth-2;arrows.forEach(function(b){var d=+b.getAttribute('data-rv-arrow');b.disabled=d<0?track.scrollLeft<=2:track.scrollLeft>=max;});}
    arrows.forEach(function(b){b.addEventListener('click',function(){
      var c=track.querySelector('.rv-card');var w=c?c.getBoundingClientRect().width+14:300;
      track.scrollBy({left:(+b.getAttribute('data-rv-arrow'))*w,behavior:'smooth'});
    });});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(upd);},{passive:true});
    window.addEventListener('resize',upd);upd();

    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
        if(e.isIntersecting){if(!v.src&&v.dataset.src)v.src=v.dataset.src;if(!reduce){var p=v.play();if(p&&p.catch)p.catch(function(){});}}else v.pause();
      });},{threshold:.5});
      root.querySelectorAll('[data-rv-video]').forEach(function(v){io.observe(v);});
      /* Omslagsbilderna hämtas först när karusellen närmar sig skärmen: en <video poster> laddas annars direkt och tog 330 kB från produktbilden (6 okt). */
      /* Hela karusellen på en gång: kort utanför karusellens synliga del räknas annars aldrig som synliga och stod tomma. */
      var pio=new IntersectionObserver(function(es){if(es.some(function(e){return e.isIntersecting;})){pio.disconnect();root.querySelectorAll('[data-rv-video][data-poster]').forEach(function(v){v.poster=v.dataset.poster;});}},{rootMargin:'800px 0px'});
      pio.observe(root);
    } else root.querySelectorAll('[data-rv-video][data-poster]').forEach(function(v){v.poster=v.dataset.poster;});

    var lb=root.querySelector('[data-rv-lb]'),box=root.querySelector('[data-rv-lb-media]'),last=null;
    function close(){lb.hidden=true;box.innerHTML='';document.documentElement.style.overflow='';if(last&&last.focus)last.focus();}
    root.querySelectorAll('[data-rv-open]').forEach(function(btn){btn.addEventListener('click',function(){
      var v=btn.querySelector('video'),im=btn.querySelector('img');box.innerHTML='';
      if(v){var n=document.createElement('video');n.src=v.dataset.src;n.poster=v.poster||v.dataset.poster||'';n.controls=true;n.muted=true;n.loop=true;n.playsInline=true;n.autoplay=true;box.appendChild(n);}
      else if(im){var i=document.createElement('img');i.src=im.src;i.alt=im.alt;box.appendChild(i);}
      last=btn;lb.hidden=false;document.documentElement.style.overflow='hidden';lb.querySelector('.rv-lb__x').focus();
    });});
    var more=root.querySelector('[data-rvl-more]');
    if(more)more.addEventListener('click',function(){
      var dolda=root.querySelectorAll('.rvl-item.is-hidden');
      for(var i=0;i<dolda.length&&i<6;i++)dolda[i].classList.remove('is-hidden');
      if(dolda.length<=6)more.hidden=true;
    });
    lb.querySelectorAll('[data-rv-close]').forEach(function(b){b.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(!lb.hidden&&e.key==='Escape')close();});
  });
})();
